import React from "react";
import PieChart from "../piechart";

const Flavor = ({ HighchartsReact, Highcharts, data }) => {
  return (
    <>
      <PieChart
        title={"Win % per brand"}
        // title={"Flavours"}
        colors={["#fc5a8d  ", "#F3E5AB", "#D2691E", "green"]}
        data={data}
        // data={[
        //   {
        //     name: "Strawberry",
        //     y: 123,
        //   },
        //   {
        //     name: "Vanilla",
        //     y: 56,
        //   },
        //   {
        //     name: "Choco",
        //     y: 36,
        //   },
        //   {
        //     name: "DT",
        //     y: 0,
        //   },
        // ]}
        Highcharts={Highcharts}
        HighchartsReact={HighchartsReact}
      />

      <div className="w-full min-h-[300px]">
        <table className=" w-full">
          <thead className="bg-[#F4F4F4] rounded h-14 w-full">
            <tr className="w-full">
              <th className=" md:w-[70%] w-[60%] text-left text-xs md:text-sm pl-6 text-[#24211D]">
                Brand
              </th>

              <th className=" text-left mr-2 pl-6 text-xs md:text-sm text-[#24211D]">
                Number of Entries
              </th>
            </tr>
          </thead>

          <tbody>
            {data.map((item, index) => (
              <tr key={index} className="  border-b">
                <td className="text-left text-xs md:text-sm text-[#787878] py-3 pl-6">
                  {item?.name}
                </td>
                <td className="text-right pr-7 text-xs md:text-sm text-[#00C74C] py-3 pl-6">
                  {item?.y ?? 0}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {data?.length < 1 && (
          <div className="flex items-center justify-center mt-5">
            <img src={require("../../../../assets/images/noData.svg")} alt="" />
          </div>
        )}
      </div>
    </>
  );
};

export default Flavor;
